// assets
import { IconCards } from '@tabler/icons';

// constant
const icons = {
    IconCards
};

// ==============================|| UTILITIES MENU ITEMS ||============================== //

const Pancard = {
    id: 'Pancard',
    title: 'PAN Card',
    type: 'group',
    children: [
        {
            id: 'tabler-icons98',
            title: 'PAN Card',
            icon: icons.IconCards,
            type: 'item',
            url: '/pancard/pancard-register',
            breadcrumbs: false
        }
    ]
};

export default Pancard;
